/**
 * 동일 RGB URL에 대해 naturalWidth/Height를 한 번만 Image로 읽고 재사용한다.
 * DotSolarMap.loadActualImageSize 와 ImageZoomViewer 가 각각 new Image() 하던 중복을 줄인다.
 * (GeoImageSource·SVG image 의 url 로드는 브라우저/OL 쪽에서 별도 — 여기서는 크기 프로브만 공유)
 */

import { processImageUrlForCdn } from '@/utils/imagePolygonManager/imageLoader';

const settled = new Map();
const inflight = new Map();

/**
 * @param {string} imageUrl
 * @returns {Promise<{ width: number, height: number } | null>}
 */
export function getRgbImageNaturalSize(imageUrl) {
  if (!imageUrl) {
    return Promise.resolve(null);
  }
  const probeUrl = processImageUrlForCdn(imageUrl);
  if (settled.has(probeUrl)) {
    return Promise.resolve(settled.get(probeUrl));
  }
  if (inflight.has(probeUrl)) {
    return inflight.get(probeUrl);
  }

  const p = new Promise((resolve) => {
    const img = new Image();
    let done = false;
    const finish = (value) => {
      if (done) return;
      done = true;
      if (value) {
        settled.set(probeUrl, value);
      }
      inflight.delete(probeUrl);
      resolve(value);
    };

    const timeoutId = setTimeout(() => {
      console.warn('[rgbImageNaturalSizeCache] timeout:', probeUrl);
      finish(null);
    }, 5000);

    img.onload = () => {
      clearTimeout(timeoutId);
      finish({
        width: img.naturalWidth,
        height: img.naturalHeight
      });
    };
    img.onerror = () => {
      clearTimeout(timeoutId);
      finish(null);
    };
    img.src = probeUrl;
  });

  inflight.set(probeUrl, p);
  return p;
}

export function invalidateRgbImageNaturalSize(imageUrl) {
  if (imageUrl) {
    settled.delete(processImageUrlForCdn(imageUrl));
    settled.delete(imageUrl);
  }
}
